import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onChangeLanguage,
  onCreateUser,
  onDeleteUser,
  onGetAllUsers,
  onGetUser,
  onGetUserDetail,
  onGetUserRoles,
  onUpdateUser,
} from '../../../app/modules/base-definitions/components/users/core/_request'

interface UserState {
  users: any
  user: any
  userDetail: any
  roles: any
  mappedRoles: any
  isLoading: boolean
}

const initialState = {
  users: [],
  user: null,
  userDetail: null,
  roles: [],
  mappedRoles: [],
  isLoading: true,
} as UserState

export const createUser = createAsyncThunk('user/createUser', async (param: any) => {
  const data: any = await onCreateUser(param)
  return data.data
})

export const updateUser = createAsyncThunk('user/updateUser', async (param: any) => {
  const data: any = await onUpdateUser(param)
  return data.data
})

export const deleteUser = createAsyncThunk('user/deleteUser', async (param: any) => {
  const data: any = await onDeleteUser(param)
  return data.data
})

export const fetchUser = createAsyncThunk('user/fetchUser', async (param: any) => {
  const data: any = await onGetUser(param)
  return data.data.result
})

export const fetchUsers = createAsyncThunk('user/fetchUsers', async (param: any) => {
  const data: any = await onGetAllUsers(param)
  return data.data.result
})

export const fetchRoles = createAsyncThunk('user/fetchRoles', async () => {
  const data: any = await onGetUserRoles()
  return data.data.result
})

export const setLanguage = createAsyncThunk('user/setLanguage', async (param: any) => {
  const data: any = await onChangeLanguage(param)
  return data.data.result
})

export const fetchUserDetail = createAsyncThunk('user/fetchUserDetail', async () => {
  const data: any = await onGetUserDetail()
  return data.data.result
})

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUsers: (state) => {
      state.users = []
    },
    clearUser: (state) => {
      state.user = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
    setMappedRoles: (state, action) => {
      state.mappedRoles = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUsers.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchUsers.fulfilled, (state: any, action) => {
      state.users = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchUserDetail.fulfilled, (state: any, action) => {
      state.userDetail = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchUsers.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchRoles.fulfilled, (state: any, action) => {
      state.roles = action.payload
    })
    builder.addCase(fetchUser.fulfilled, (state: any, action) => {
      state.user = action.payload
    })
  },
})

export const {clearUsers, clearUser, activateLoading, setMappedRoles} = userSlice.actions

export default userSlice.reducer
